/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGoogleCustomSearch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4.383 13.522c1.964 2.852 5.887 3.66 8.83 1.715.186-.123.358-.119.516.01l-3.366 5.832-.503.833c-.016.027-.028.055-.042.082L6.133 22c-.827 0-1.655.003-2.481-.001-.898-.004-1.649-.744-1.65-1.638C2 17.287 2 14.213 2 11.14z" />
        <path d="M22 20.287c0 .865-.564 1.54-1.411 1.692a1.25 1.25 0 0 1-.22.02H10.6l3.62-6.271a.503.503 0 0 1 .04.04c.123.127.344.232.341.387-.003.143-.217.25-.349.359-.123.1-.11.162-.001.27 1.422 1.414 2.84 2.833 4.255 4.254.098.098.151.114.258.006.68-.69 1.364-1.377 2.056-2.055.122-.12.105-.176-.006-.286-1.352-1.345-2.7-2.695-4.048-4.043-.083-.083-.168-.164-.247-.25-.06-.064-.105-.067-.164.002-.096.112-.208.213-.3.329-.092.117-.157.13-.269.01-.256-.274-.53-.535-.796-.8-.127-.129-.141-.265-.041-.41a6.428 6.428 0 0 0-2.188-9.289L22 4.01v16.278zM9.833 21.996l-.015-.002c.014-.027.026-.055.042-.082.16-.266.322-.53.482-.797z" />
        <path d="M9.684 5.44c2.488.004 4.437 1.982 4.431 4.496-.005 2.43-2.01 4.4-4.466 4.393-2.491-.009-4.449-2-4.419-4.549.03-2.456 2.055-4.36 4.454-4.34z" />
        <path d="M20.301 2c.835.001 1.525.584 1.667 1.343l-10.835.285a6.42 6.42 0 0 0-7.614 8.086L2.004 10.2v-.006C2.005 10.07 2 9.948 2 9.825V3.712C2 2.734 2.73 2 3.708 2H20.3z" />
      </g>
    </g>
  </Icon>
);
export { SvgGoogleCustomSearch as GoogleCustomSearch };
